<template>
<div>
  <Modal titulo="Artículo" @close="toggleModal" :modalActive="true">
      <div class="row">
           <div class="m-auto mt-3 mb-3" v-if="pais == 'Peru' && false">
             <button class="btn btn-primary b-radius text-uppercase fw-bold" @click="toggleModalImeiOsiptel">Check Imeis</button>
           </div>

               <div class="col-md-12 form-floating  mb-3">
                 <div class="row">

               <div class="col-md-12 mb-3" v-if="resetFieldTypeHead">
                   <div class="form-floating position-relative">
                   <vue3-simple-typeahead
                       class="form-control text-center fw-bold"
                       id="typeahead_articulos_historial"
                       placeholder="Escriba el nombre del artículo"
                       :defaultItem="articulo.nombre"
                       :items="articulos"
                       :minInputLength="1"
                       @onInput="getArticulo"
                       @selectItem="selectArticulo"
                   >
                   </vue3-simple-typeahead>
                   <span v-if="loaderInputArticulos" class="spinner-border spinner-border-sm loader-input-articulos" role="status"></span>
                   </div> 
                   </div>

               <div class="col-md-6 mb-3">
                     <div class="form-floating">
                       <input type="number" class="form-control text-center fw-bold" v-model="articulo.cantidad" placeholder="Cantidad" autocomplete="off" min="1" oninput="this.value = Math.abs(this.value)">
                       <label for="floatingInput">Cantidad <span class="text-danger fw-bold">[*]</span></label>
                     </div>
                 </div>
      
      
               <div class="col-md-6 mb-3 m-auto">
                    <div class="form-floating">
                      <input type="number" class="form-control text-center fw-bold" v-model="articulo.costo" :placeholder="'Valor Declarado en ' + articulo.divisa" autocomplete="off" min="1">
                      <label for="floatingInput">Costo Producto <span class="text-danger fw-bold">[*]</span></label>
                    </div>
                 </div>


            <div class="col-md-12 d-flex">
            <div class="form-check fs-xl-2 m-auto">
              <input class="form-check-input" v-model="articulo.bateria" type="checkbox" id="checkBattery">
              <label class="form-check-label" for="checkBattery">
               Contiene Bateria?
              </label>
            </div>
            </div>

      </div>
      
      </div>

      </div>

    <div class="buttons-modal-footer">
          <button @click="coreProduct" type="button" class="btn-modal-crear w-90 b-radius">{{!article ? 'Agregar' : 'Actualizar'}}</button>
     </div>
    </Modal>

    <ModalImeiOsiptel @toggleModal="toggleModalImeiOsiptel()" v-if="modalActiveImeiOsiptel" />

    </div>
</template>

<script setup>
import ModalImeiOsiptel from '@/components/modals/imei-osiptel/Consulta-Imei.vue'
import {getArticulos, dataDivisaByPais} from '@/helpers'
import {reactive, ref, onMounted} from 'vue'
import { useToast } from "vue-toastification";
import { useProductsCartStore } from "@/store/productsCart";

const toast = useToast();
const resetFieldTypeHead = ref(true)
const loaderInputArticulos = ref(false)

const props = defineProps({
  pais: String,
  article: null
})

const emit = defineEmits(['toggleModal', 'productoActualizado'])
const articulos = ref([])
const divisaArticulo = ref([])

const articulo = reactive({
    id: props.article ? props.article.id : '',
    nombre: props.article ? props.article.producto : '',  
    cantidad: props.article ? props.article.cantidad : '', 
    divisa: props.article ? props.article.divisa : 'Dolares',
    divisa_simbolo: props.article ? props.article.divisa_simbolo : '$',
    costo: props.article ? props.article.costo : '',
    bateria: props.article ? props.article.bateria : 0,
})

const modalActiveImeiOsiptel = ref(false)

const toggleModalImeiOsiptel = () => {
   modalActiveImeiOsiptel.value = !modalActiveImeiOsiptel.value
}

//Logica store articulos cart 
const productsCart = useProductsCartStore()

const coreProduct = () => {
    if(articulo.nombre !== "" 
        && (articulo.cantidad !== "" || articulo.cantidad > 0) 
        && (articulo.costo !== "" && articulo.costo > 0) 
        && articulo.divisa !== "" 
        && articulo.divisa_simbolo !== ""){

        if(props.article){
          productsCart.updateProduct(articulo)
          emit('productoActualizado')
          toast.success('Artículo actualizado correctamente', 2000)
          toggleModal()
        }else{
          productsCart.addProduct(articulo)
          emit('productoActualizado')
          toast.success('Artículo agregado correctamente', 2000)
          resetArticulos()
        }

    }else{
        toast.info('Complete toda la información del artículo', 3000)
    }
}

const getArticulo = async (e) => {
    loaderInputArticulos.value = true
    var search = e.input
    let jsonArticulos = []
    
    // Check if input is empty to avoid unnecessary calls
    if(!search) {
        articulos.value = []
        loaderInputArticulos.value = false
        return
    }

    const dataArticulos = await getArticulos(search) 
    
    if(dataArticulos){
         dataArticulos.map(function(item) {
            jsonArticulos.push(item.articulo)
        })
    }
   
    articulos.value = jsonArticulos
    loaderInputArticulos.value = false 
    articulo.nombre = e.input
}

const selectArticulo = (e) => {
    articulo.nombre = e
}

onMounted(async () => {
  productsCart.pais = props.pais
  let divisaFilter = dataDivisaByPais(props.pais)
  divisaArticulo.value = divisaFilter.divisas
})

const toggleModal = () => {
    emit('toggleModal', false)
};

const resetArticulos = () => {
    articulo.nombre = ''
    articulo.cantidad  = '' 
    articulo.divisa = 'Dolares'
    articulo.divisa_simbolo = '$' 
    articulo.costo = ''
    articulo.bateria  = 0
    resetFieldTypeHead.value = !resetFieldTypeHead.value
    // Timeout to force re-render of typeahead component to clear it
    setTimeout(() => {
    resetFieldTypeHead.value = !resetFieldTypeHead.value
    }, 50);
}
</script>

